import { FC, ReactNode, CSSProperties } from "react";
import S from "./index.module.scss";

interface IHeaderImage {
  image: string;
  children: ReactNode;
}

const HeaderImage: FC<IHeaderImage> = ({ children, image }) => {
  return (
    <section className={S.headerBackgroundImage} style={{ backgroundImage: `url(${image})` } as CSSProperties}>
      <div className={S.contentWrapper}>{children}</div>
    </section>
  );
};

export default HeaderImage;
